<div class="login-container">
    <div>
        <img class="mx-auto d-block logo-image" src="assets/img/img_logo.png" />
    </div>
    <form class="mt-4 ml-md-5 mr-md-5" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="form-group ml-md-5 mr-md-5">
            <label for="emailInput">{{ "LOGIN_COMPONENT_EMAIL_LABEL" | translate }}</label>
            <input type="email" class="form-control" id="emailInput" aria-describedby="emailHelp" formControlName="email" />
        </div>
        <div class="form-group ml-md-5 mr-md-5">
            <label for="passwordInput">{{ "LOGIN_COMPONENT_PASSWORD_LABEL" | translate }}</label>
            <input type="password" class="form-control" id="passwordInput" formControlName="password" />
        </div>
        <button class="btn w-100 py-1 mt-2 submit-btn" [disabled]="!loginForm.valid">{{
            "LOGIN_COMPONENT_SUBMIT_BUTTON" | translate
        }}</button>
    </form>
    <br />
    <div class="text-center" style="font-size: 13px;">
        <p [innerHtml]="'LOGIN_COMPONENT_REGISTER_LABEL' | translate" class="mb-2"></p>
        <p [innerHtml]="'LOGIN_COMPONENT_PASSWORD_RESET_LABEL' | translate"></p>
    </div>
    <hr /><br />
    <div class="version text-center mt-4 version">
        <span>v{{ appVersion }}</span>
    </div>
</div>
